"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentPlanTransaction_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var PaymentPlanSchedule_1 = require("./PaymentPlanSchedule");
var Transaction_1 = require("./Transaction");
var PaymentPlanTransaction_Factory = /** @class */ (function () {
    function PaymentPlanTransaction_Factory() {
    }
    PaymentPlanTransaction_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Amount: model.Amount,
            PaymentPlanSchedule: PaymentPlanSchedule_1.PaymentPlanSchedule_Factory.CreateIncoming(model.PaymentPlanSchedule),
            PaymentPlanScheduleId: model.PaymentPlanScheduleId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            Transaction: Transaction_1.Transaction_Factory.CreateIncoming(model.Transaction),
            TransactionId: model.TransactionId,
        };
        return result;
    };
    PaymentPlanTransaction_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Amount: model.Amount,
            PaymentPlanSchedule: PaymentPlanSchedule_1.PaymentPlanSchedule_Factory.CreateOutgoing(model.PaymentPlanSchedule),
            PaymentPlanScheduleId: model.PaymentPlanScheduleId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            Transaction: Transaction_1.Transaction_Factory.CreateOutgoing(model.Transaction),
            TransactionId: model.TransactionId,
        };
        return result;
    };
    return PaymentPlanTransaction_Factory;
}());
exports.PaymentPlanTransaction_Factory = PaymentPlanTransaction_Factory;
